import type { I18nLocale } from '#/i18n/types/I18nLocale';

type Args = {
  locale: I18nLocale;
  currencyCode: string | undefined;
};

export function currencyInputDelimiterGetMaxDecimalPlaces({
  locale,
  currencyCode,
}: Args) {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode ?? 'USD',
  });

  // Ensure we cover all possible decimal values (max is 4 according to ISO_4217)
  const parts = formatter.formatToParts(1.11111);
  const decimalPart = parts.find((part) => part.type === 'decimal');
  const fractionPart = parts.find((part) => part.type === 'fraction');

  if (decimalPart && fractionPart) {
    return fractionPart.value.length;
  }

  return 0;
}
